import React, { useState } from 'react'

import { SearchField } from '@octane/spark'
import useLeadsPageContext from 'pages/LeadsPage/LeadsPageContext'
import { pushLeadsSearchQuery } from 'utils/gtm-utils'

import { Container } from './LeadsSearch.styled'

function LeadsSearch(): JSX.Element {
    const [search, setSearch] = useState<string>('')
    const { setSearch: setSearchCtx } = useLeadsPageContext()

    return (
        <Container>
            <SearchField
                value={search}
                onChange={(e) => setSearch(e)}
                placeholder="Search by Name or Vehicle"
                onSearch={() => {
                    pushLeadsSearchQuery(search)
                    setSearchCtx(search)
                }}
                size="small"
            />
        </Container>
    )
}

export default LeadsSearch
